
import { Navigation } from './components/navigation'
import { LogoHero } from './components/LogoHero'
import { LogoShowcase } from './components/LogoShowcase'
import { LogoPricing } from './components/LogoPricing'
import { Footer } from './components/footer'
import { BackToTop } from './components/BackToTop'
import { WhatsAppFloat } from './components/WhatsAppFloat'

const phoneNumber = "1234567890"; // Replace with your actual phone number

export default function LogoDesign() {
  return (
    <main className="min-h-screen font-poppins flex flex-col">
      <Navigation />
      <LogoHero />
      <LogoShowcase />
      <LogoPricing phoneNumber={phoneNumber} />
      <Footer />
      <WhatsAppFloat phoneNumber={phoneNumber} />
      <BackToTop />
    </main>
  )
}

